/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aloof_Antsy_Buzzard_PoutInputs */

const fr_aloof_antsy_buzzard_pout = /** @type {(inputs: Aloof_Antsy_Buzzard_PoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poids de la barre`)
};

/**

* @param {Aloof_Antsy_Buzzard_PoutInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aloof_antsy_buzzard_pout = /** @type {((inputs?: Aloof_Antsy_Buzzard_PoutInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aloof_Antsy_Buzzard_PoutInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aloof_antsy_buzzard_pout(inputs)
});